import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { FormsService } from '../shared/forms.service';
import { HttpService } from '../shared/http.service';
import { ListCategoriesComponent } from './list/list-categories/list-categories.component';
import { SubscriberCreateComponent } from './subscriber/subscriber-create/subscriber-create.component';
import { SubscriberFormComponent } from './subscriber/shared/subscriber-form/subscriber-form.component';
import { ListMembersComponent } from './list/list-members/list-members.component';

@NgModule({
  imports: [
    SharedModule,
  ],
  providers: [
    FormsService,
    HttpService
  ],
  declarations: [
    ListCategoriesComponent,
    SubscriberCreateComponent,
    SubscriberFormComponent,
    ListMembersComponent
  ]
})
export class MailchimpModule { }



// WEBPACK FOOTER //
// ./src/app/mailchimp/mailchimp.module.ts